import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ParameterCreateUpdate from "./create-update";
import { SamplingScheduleItem } from "../../../models/types/samplingSchedules";
import samplingScheduleSvc from "../../../services/api/samplingSchedules";
import Loading from "../../../components/loading/loading";

export default function SamplingScheduleCreateUpdatePage() {
    const { stationId, id } = useParams<{ stationId?: string, id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<SamplingScheduleItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            samplingScheduleSvc.getDetail(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ParameterCreateUpdate isCreate={isCreate} stationId={stationId!} data={data} />}
        </div>
    );
}